import { Job, SupabaseJob } from '@applicator/shared'

import ConfirmDialog from '../../ConfirmDialog'
import ReviewMatchingRules from '../../ReviewMatchingRules'

interface DeleteConfirmDialogProps {
  deleteConfirm: {
    isOpen: boolean
    type: 'single' | 'bulk'
    message: string
    jobIds: string[]
    rowIndex?: number
  } | null
  onConfirm: () => Promise<void>
  onCancel: () => void
  setError: (error: string) => void
}

export function DeleteConfirmDialog({ deleteConfirm, onConfirm, onCancel, setError }: DeleteConfirmDialogProps) {
  return (
    <ConfirmDialog
      isOpen={deleteConfirm?.isOpen || false}
      title="Delete Job"
      message={deleteConfirm?.message || ''}
      confirmText="Delete"
      cancelText="Cancel"
      variant="danger"
      onConfirm={async () => {
        try {
          console.log('[JobsTable] Delete confirmation clicked', { deleteConfirm })
          await onConfirm()
        } catch (error) {
          console.error('[JobsTable] Error in delete confirmation:', error)
          setError(error instanceof Error ? error.message : 'Failed to delete job')
        }
      }}
      onCancel={onCancel}
    />
  )
}

interface ReviewRulesDialogProps {
  reviewRulesJob: { job: Job; supabaseJob: SupabaseJob } | null
  onClose: () => void
  onRulesUpdated: () => void
}

export function ReviewRulesDialog({ reviewRulesJob, onClose, onRulesUpdated }: ReviewRulesDialogProps) {
  if (!reviewRulesJob) return null

  return (
    <ReviewMatchingRules
      job={reviewRulesJob.job}
      supabaseJob={reviewRulesJob.supabaseJob}
      isOpen={!!reviewRulesJob}
      onClose={onClose}
      onRulesUpdated={onRulesUpdated}
    />
  )
}
